// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullBanner,
} from 'common.data';

// Global Components
import * as React from 'react';

// Helpers
import _ from 'lodash';
import {
  getFileUrl,
} from '@vroskus/library-helpers/dist/browser';
import config from '../../../../config';

// Components
import Section from '../../../layout/Section';

// Types
type $Props = $Translate & {
  data: Array<$FullBanner>;
  id: string;
};

type $State = {
  dataItem?: $FullBanner;
};

const loopInterval: number = 10000;

class BannersSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      dataItem: _.sample(props.data),
    };
  }

  componentDidMount(): void {
    const {
      data,
    } = this.props;

    setInterval(
      () => this.setState({
        dataItem: _.sample(data),
      }),
      loopInterval,
    );
  }

  renderImage(dataItem: $FullBanner) {
    const {
      t,
    } = this.props;

    const altText = t('Banner');
    const commonClassName = 'w-full rounded-lg';

    return (
      <>
        <img
          alt={altText}
          className={`${commonClassName} hidden lg:block`}
          src={getFileUrl({
            cdnUrl: config.CDN_URL,
            file: dataItem.ImageLG,
          })}
        />
        <img
          alt={altText}
          className={`${commonClassName} hidden md:block lg:hidden`}
          src={getFileUrl({
            cdnUrl: config.CDN_URL,
            file: dataItem.ImageMD,
          })}
        />
        <img
          alt={altText}
          className={`${commonClassName} hidden sm:block md:hidden`}
          src={getFileUrl({
            cdnUrl: config.CDN_URL,
            file: dataItem.ImageSM,
          })}
        />
        <img
          alt={altText}
          className={`${commonClassName} sm:hidden`}
          src={getFileUrl({
            cdnUrl: config.CDN_URL,
            file: dataItem.ImageXS,
          })}
        />
      </>
    );
  }

  renderButton(dataItem: $FullBanner) {
    const {
      t,
    } = this.props;

    return (dataItem.ButtonLink ? (
      <a
        className={`absolute btn ${dataItem.ButtonClass || 'top-2 bottom-2 right-2 left-2'}`}
        href={dataItem.ButtonLink}
        title={t('Action')}
      >
        {dataItem.ButtonName}
      </a>
    ) : null);
  }

  renderDataItem(dataItem: $FullBanner) {
    if (dataItem.ButtonLink !== null) {
      return dataItem.ButtonName !== null ? (
        <>
          {this.renderImage(dataItem)}
          {this.renderButton(dataItem)}
        </>
      ) : (
        <a
          className={'flex items-center'}
          href={dataItem.ButtonLink}
          key={dataItem.id}
          rel={'noreferrer'}
          target={'_blank'}
        >
          {this.renderImage(dataItem)}
        </a>
      );
    }

    return this.renderImage(dataItem);
  }

  render() {
    const {
      id,
    } = this.props;
    const {
      dataItem,
    } = this.state;

    return (
      <Section id={id}>
        {dataItem && (
          <div className={'-m-5 left-5 right-5'}>
            <div
              className={dataItem.ContainerClass || 'relative'}
              key={dataItem.id}
            >
              {this.renderDataItem(dataItem)}
            </div>
          </div>
        )}
      </Section>
    );
  }
}

export default BannersSectionView;
